import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * XP for testing a new discover search endpoint implementation
 * This is only for migration of search endpoints. Monolith endpoints should use an different XP setting.
 */
export const FE_MIGRATE_DISCOVER_LAYOUT_CALLS_250424 = experiment({
  name: "FE_MIGRATE_DISCOVER_LAYOUT_CALLS_250424",
  identifier: "SessionToken",
  client: [
    "RETAILER",
    "RETAILER_HEAD_TAGS",
    "VISITOR_WEB_HEAD_TAGS",
    "VISITOR_WEB",
  ],
  notifyAfter: "2025-08-29",
  defaultValue: false,
  productArea: "LOGGED_OUT_RETAILERS",
});
